<template>
  <header class="admin-header">
    <div class="user-panel">
      <ul>
        <li>
          <span class="navbar-avator"><img :data-src="userInfo.logoUrl | imageUrl" :src="userInfo.logoUrl | imageUrl('?imageView2/1/w/60/h/60', './assets/img/header_user.png')" /></span>
          <span class="navbar-user-name">{{userInfo.nickName}}</span>
        </li>
        <li>
          <a href="javascript:void(0);" @click="onLogout">退出</a>
        </li>
      </ul>
    </div>
  </header>
</template>
<script>
import { logout } from '@/api/admin'

export default {
  data: () => ({
    userInfo: {}
  }),
  watch: {
    $route: function(route) {
      this.userInfo =
        (localStorage.getItem('userInfo') &&
          JSON.parse(localStorage.getItem('userInfo'))) ||
        {}
    }
  },
  methods: {
    //  退出登录
    onLogout() {
      logout().then(response => {
        this.$message({
          type: 'success',
          message: '退出成功'
        })
        localStorage.clear()
        this.$router.push({ path: '/', query: { logout: +new Date() } })
      })
    }
  },
  created() {
    this.userInfo =
      (localStorage.getItem('userInfo') &&
        JSON.parse(localStorage.getItem('userInfo'))) ||
      {}
  }
}
</script>
<style>
.admin-header {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  height: 56px;
  background: #fff;
  box-shadow: 0px 2px 1px 0px rgba(22, 50, 92, 0.1);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  z-index: 100;
}

.admin-header .user-panel {
  height: 30px;
  padding-right: 24px;
  overflow: hidden;
}
.admin-header .user-panel li {
  position: relative;
  float: left;
  padding: 0 12px;
  line-height: 30px;
}
.admin-header .user-panel li:last-child {
  padding-right: 0;
}
.admin-header .user-panel li:last-child::after {
  display: none;
}
.admin-header .user-panel li:after {
  content: ' ';
  position: absolute;
  top: 50%;
  right: -2px;
  width: 2px;
  height: 12px;
  background-color: #6a6a6a;
  transform: translateY(-50%);
}
.admin-header .user-panel .navbar-avator {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin-right: 10px;
  vertical-align: top;
  border-radius: 50%;
  overflow: hidden;
}
.admin-header .user-panel .navbar-avator img {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
